import { FiChevronDown, FiChevronRight } from './react-icons/main/index.esm';
import React from 'react';

const ToggleIndicator = ({ isOpen }) => <div className="comp-toggle-indicator">{isOpen ? <FiChevronDown /> : <FiChevronRight />}</div>;

export default ToggleIndicator;
